var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducation = function SvgEducation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.486 2.143a1 1 0 0 1 1.028 0l10 6A1 1 0 0 1 23 9v5a1 1 0 1 1-2 0v-3.234L18.944 12H19v6.182c0 .379-.214.724-.553.895l-.15.075-.34.172-.008.005c-1.571.8-3.273 1.667-5.949 1.667-2.678 0-4.379-.867-5.951-1.668q-.25-.129-.496-.251A1 1 0 0 1 5 18.182V12h.056l-3.57-2.143a1 1 0 0 1 0-1.714zm1.028 13.715L17 13.166v4.398l-.975.487a9.04 9.04 0 0 1-8.05 0L7 17.564v-4.398l4.486 2.691a1 1 0 0 0 1.028 0M3.944 9 12 13.834 20.056 9 12 4.166z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21 17a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0z"
  })));
};
export default SvgEducation;